import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
// Figma の矢印（Frame 24277）は 27x24。SVG エクスポートは drop-shadow(blur 5px) を含み 41.29x34.37 のため、
// レイアウト枠は 27x24 に保ったまま、負のインセット（Figma と同値）で影を枠外へオーバーフローさせる。
export const SpecialPlanArrowIcon = ({ classObject }) => {
    return (React.createElement("div", { className: css(styles.container, classObject), "aria-hidden": true },
        React.createElement("div", { className: css(styles.inner) },
            React.createElement("img", { className: css(styles.img), src: "/assets/images/icons/special_plan_arrow.svg", alt: "" }))));
};
const styles = StyleSheet.create({
    container: {
        position: 'relative',
        width: 27,
        height: 24,
    },
    inner: {
        position: 'absolute',
        top: '-20.83%',
        right: '-26.47%',
        bottom: '-22.39%',
        left: '-26.47%',
    },
    img: {
        display: 'block',
        width: '100%',
        height: '100%',
        maxWidth: 'none',
    },
});
